var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var MissedAppointment = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H4C2.34315 4 1 5.34315 1 7V19C1 20.6569 2.34315 22 4 22H20C21.6569 22 23 20.6569 23 19V7C23 5.34315 21.6569 4 20 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4H8V3ZM16 7V6H8V7C8 7.55228 7.55229 8 7 8C6.44772 8 6 7.55228 6 7V6H4C3.44772 6 3 6.44772 3 7V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V7C21 6.44772 20.5523 6 20 6H18V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7ZM15.7108 10.2929C15.3202 9.90237 14.6871 9.90237 14.2966 10.2929L12.0018 12.5876L9.70711 10.2929C9.31659 9.90237 8.68342 9.90237 8.2929 10.2929C7.90237 10.6834 7.90237 11.3166 8.2929 11.7071L10.5876 14.0018L8.2929 16.2966C7.90237 16.6871 7.90237 17.3202 8.2929 17.7108C8.68342 18.1013 9.31659 18.1013 9.70711 17.7108L12.0018 15.416L14.2966 17.7108C14.6871 18.1013 15.3202 18.1013 15.7108 17.7108C16.1013 17.3202 16.1013 16.6871 15.7108 16.2966L13.416 14.0018L15.7108 11.7071C16.1013 11.3166 16.1013 10.6834 15.7108 10.2929Z", fill: "currentColor" }) })));
};
